import { createSIPUri, MediaParticipant, useSession, useSipClient } from "@dvrt/web-phone-client";
import { useSettings } from "../../tools";

export function useParticipantList(): MediaParticipant[] {
    const sipClient = useSipClient();
    const { participants } = useSession();
    const settings = useSettings();

    const selfCname = createSIPUri(sipClient.sipSettings.auth);
    return [
        {
            csrc: 0,
            cname: selfCname,
            name: settings.displayName,
            videoTrack: null,
            screen: false,
        },
    ].concat(participants);
}
